var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMobilePhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3335 0.666504H5.00016C4.08016 0.666504 3.3335 1.41317 3.3335 2.33317V13.6665C3.3335 14.5865 4.08016 15.3332 5.00016 15.3332H10.3335C11.2535 15.3332 12.0002 14.5865 12.0002 13.6665V2.33317C12.0002 1.41317 11.2535 0.666504 10.3335 0.666504ZM7.66683 14.6665C7.1135 14.6665 6.66683 14.2198 6.66683 13.6665C6.66683 13.1132 7.1135 12.6665 7.66683 12.6665C8.22016 12.6665 8.66683 13.1132 8.66683 13.6665C8.66683 14.2198 8.22016 14.6665 7.66683 14.6665ZM10.6668 11.9998H4.66683V2.6665H10.6668V11.9998Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMobilePhone);
export default __webpack_public_path__ + "static/media/icon-mobile-phone.b50c17a2a3d32957333ac3685abb1813.svg";
export { ForwardRef as ReactComponent };